import { Box, H1, Text } from '@betterment/samba-react';

import SuccessCheckmark from '../Shared/components-v2/success-checkmark/success-checkmark';

const EmailConfirmationSuccess = () => (
  <Box css={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', pb: 'space.800' }}>
    <SuccessCheckmark />
    <Box css={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', gap: 'space.200' }}>
      <H1 css={{ textAlign: 'center' }} variant="title300">
        Nice! Your email has been verified
      </H1>
      <Text css={{ textAlign: 'center' }} variant="text200">
        You can close out of this tab and return to where you came from
      </Text>
    </Box>
  </Box>
);

export default EmailConfirmationSuccess;
